import image from '../loading.svg'
export default function Loading({ styles }) {
  return (
    <>
      <div className={`loading ${styles}`}>
        <img src={image} alt='loading' />
      </div>
    </>
  )
}
